/**
 * @generated SignedSource<<add826c13a3e576499b46fa7e08c1356>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MeetingModal_note$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"MeetingContent_note">;
  readonly " $fragmentType": "MeetingModal_note";
};
export type MeetingModal_note$key = {
  readonly " $data"?: MeetingModal_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"MeetingModal_note">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MeetingModal_note",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MeetingContent_note"
    }
  ],
  "type": "Note",
  "abstractKey": null
};

(node as any).hash = "45b12e0e8582640235227465e687a9f6";

export default node;
